// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar.navbar-expand-lg {
    background-color: #FFF;
    min-height: 138px;
    margin: 0;
    padding: 0;
}

.navbar-brand {
    align-self: center;
}

.sticky-top {
    z-index: 10;
}

.navbar-nav li {
    padding: 1px;
    box-sizing: border-box;
    margin: 0 13px;
    align-self: baseline;
}

.navbar-nav li a {
    text-align: center;
    box-sizing: border-box;
    color: #0B0C0C;
    font-size: 19px;
    font-weight: lighter;
}

.navbar-nav li img {
    margin-right: 8px;
}

.navbar-nav li a:hover {
    font-weight: bold;
    text-decoration: underline;
    letter-spacing: -0.03em;
}

.navbar-nav li a.active-link {
    font-weight: bold;
    text-decoration: underline;
}

.navbar-nav li a.active-link:hover {
    letter-spacing: 0em;
}

.nav-link span img {
    width: 20px;
    margin-right: 2px;
    margin-top: -1px;
}

.button1 {
    color: #222;
    box-sizing: border-box;
}

.dropdown.advice .dropdown-menu {
    box-sizing: border-box;
    height: 46px;
    padding: 0;
    border-radius: 0;
    transition: ease-out 0.3s;
    display: block;
    overflow: hidden;
    opacity: 0;
    min-width: 117px;
}

.dropdown-item:hover{
    background-color: transparent;
}

.dropdown.advice:hover .dropdown-menu {
    max-height: 46px;
    opacity: 1;
}

.custom-icon {
    display: none;
}

.button1 {
    border: 1px solid transparent;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    background-color: transparent;
    font-weight: 500;
}

.nav-menu {
    display: flex;
    flex: 1 1 auto;
    padding: 0 110px;
    /* justify-content: space-between;
    flex-direction: rows; */
}

li.nav-item a svg {
    margin-right: 5px;
    margin-bottom: -4px;
}

.mobile-nav {
    display: none;
}

@media (max-width: 1024px) {

    button {
        border: none;
        margin: 0;
    }

    button:focus {
        outline: none;
    }

    .button1 {
        font-weight: 500;
        font-size: large;
        line-height: 22px;
        color: #0B0C0C;
    }

    .menu-icon,
    #sign-in-out-logo {
        width: 40px;
        height: 40px;
    }

    #weg-navmenuComponent-navigateToLogin-link {
        padding: 0;
    }

    .navbar{
        padding:0.5rem 1rem;
        justify-content: space-between;
        &.navbar-menu-header{
            width: 100%;
            background-color: transparent !important;
            height: 72px;
            margin-bottom: 1rem;
            display: flex;
            flex-wrap: nowrap;
            padding: 0;
            justify-content: space-between;
        }
    }

    .desktop-nav {
        display: none;
        font-size: 16px;
    }

    .mobile-nav {
        display: block;
        background-color: #FFFFFF !important;
        height: -moz-fit-content;
        height: fit-content;
        width: 100%;
    }

    .navbar-brand img {
        width: 115px;
        max-height: 40px;
        margin-left: 10px;
    }

    button.navbar-toggler {
        margin-top: -6px;
    }

    .navbar-collapse ul li {
        align-self: center;
    }

    .navbar-collapse ul li a {
        font-size: 16px;
        line-height: 22px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/navmenu/navmenu.component.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,2BAA2B;IAC3B,8BAA8B;IAC9B,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB;2BACuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI;QACI,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B;YACI,WAAW;YACX,wCAAwC;YACxC,YAAY;YACZ,mBAAmB;YACnB,aAAa;YACb,iBAAiB;YACjB,UAAU;YACV,8BAA8B;QAClC;IACJ;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,oCAAoC;QACpC,wBAAmB;QAAnB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".navbar.navbar-expand-lg {\r\n    background-color: #FFF;\r\n    min-height: 138px;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.navbar-brand {\r\n    align-self: center;\r\n}\r\n\r\n.sticky-top {\r\n    z-index: 10;\r\n}\r\n\r\n.navbar-nav li {\r\n    padding: 1px;\r\n    box-sizing: border-box;\r\n    margin: 0 13px;\r\n    align-self: baseline;\r\n}\r\n\r\n.navbar-nav li a {\r\n    text-align: center;\r\n    box-sizing: border-box;\r\n    color: #0B0C0C;\r\n    font-size: 19px;\r\n    font-weight: lighter;\r\n}\r\n\r\n.navbar-nav li img {\r\n    margin-right: 8px;\r\n}\r\n\r\n.navbar-nav li a:hover {\r\n    font-weight: bold;\r\n    text-decoration: underline;\r\n    letter-spacing: -0.03em;\r\n}\r\n\r\n.navbar-nav li a.active-link {\r\n    font-weight: bold;\r\n    text-decoration: underline;\r\n}\r\n\r\n.navbar-nav li a.active-link:hover {\r\n    letter-spacing: 0em;\r\n}\r\n\r\n.nav-link span img {\r\n    width: 20px;\r\n    margin-right: 2px;\r\n    margin-top: -1px;\r\n}\r\n\r\n.button1 {\r\n    color: #222;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.dropdown.advice .dropdown-menu {\r\n    box-sizing: border-box;\r\n    height: 46px;\r\n    padding: 0;\r\n    border-radius: 0;\r\n    transition: ease-out 0.3s;\r\n    display: block;\r\n    overflow: hidden;\r\n    opacity: 0;\r\n    min-width: 117px;\r\n}\r\n\r\n.dropdown-item:hover{\r\n    background-color: transparent;\r\n}\r\n\r\n.dropdown.advice:hover .dropdown-menu {\r\n    max-height: 46px;\r\n    opacity: 1;\r\n}\r\n\r\n.custom-icon {\r\n    display: none;\r\n}\r\n\r\n.button1 {\r\n    border: 1px solid transparent;\r\n    box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n    background-color: transparent;\r\n    font-weight: 500;\r\n}\r\n\r\n.nav-menu {\r\n    display: flex;\r\n    flex: 1 1 auto;\r\n    padding: 0 110px;\r\n    /* justify-content: space-between;\r\n    flex-direction: rows; */\r\n}\r\n\r\nli.nav-item a svg {\r\n    margin-right: 5px;\r\n    margin-bottom: -4px;\r\n}\r\n\r\n.mobile-nav {\r\n    display: none;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n\r\n    button {\r\n        border: none;\r\n        margin: 0;\r\n    }\r\n\r\n    button:focus {\r\n        outline: none;\r\n    }\r\n\r\n    .button1 {\r\n        font-weight: 500;\r\n        font-size: large;\r\n        line-height: 22px;\r\n        color: #0B0C0C;\r\n    }\r\n\r\n    .menu-icon,\r\n    #sign-in-out-logo {\r\n        width: 40px;\r\n        height: 40px;\r\n    }\r\n\r\n    #weg-navmenuComponent-navigateToLogin-link {\r\n        padding: 0;\r\n    }\r\n\r\n    .navbar{\r\n        padding:0.5rem 1rem;\r\n        justify-content: space-between;\r\n        &.navbar-menu-header{\r\n            width: 100%;\r\n            background-color: transparent !important;\r\n            height: 72px;\r\n            margin-bottom: 1rem;\r\n            display: flex;\r\n            flex-wrap: nowrap;\r\n            padding: 0;\r\n            justify-content: space-between;\r\n        }\r\n    }\r\n\r\n    .desktop-nav {\r\n        display: none;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .mobile-nav {\r\n        display: block;\r\n        background-color: #FFFFFF !important;\r\n        height: fit-content;\r\n        width: 100%;\r\n    }\r\n\r\n    .navbar-brand img {\r\n        width: 115px;\r\n        max-height: 40px;\r\n        margin-left: 10px;\r\n    }\r\n\r\n    button.navbar-toggler {\r\n        margin-top: -6px;\r\n    }\r\n\r\n    .navbar-collapse ul li {\r\n        align-self: center;\r\n    }\r\n\r\n    .navbar-collapse ul li a {\r\n        font-size: 16px;\r\n        line-height: 22px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
